<template>
  <v-col :key="vastuualue.id" cols="12" lg="4" md="6" class="pb-0">
    <v-card class="mx-auto" @click="goToVastuualue(vastuualue)">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title style="word-break: break-word !important; white-space: initial;">
            {{ vastuualue.nimi }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ vastuualue.vastuuuser.firstname }}
            {{ vastuualue.vastuuuser.lastname }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-avatar class="pa-1" size="100" tile>
          <v-img v-if="vastuualue.logo" :src="vastuualue.logo" contain></v-img>
        </v-list-item-avatar>
      </v-list-item>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "VastuualueBox",
  props: {
    vastuualue: {
      required: true,
      type: Object
    },
  },
  data() {
    return {}
  },
  methods: {
    goToVastuualue(vastuualue) {
      this.$router.push({name: 'vastuualue', params: {id: vastuualue.id}})
    },
  }
}
</script>

<style scoped>

</style>